import { useProfile } from "../context/ProfileContext";

export default function Footer() {
  const PROFILE = useProfile();
  return (
    <footer className="relative bg-[#0A0A0A] border-t border-white/10 overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div
          className="font-display font-black text-white/[0.03] uppercase tracking-tighter leading-none select-none"
          style={{ fontSize: "clamp(8rem, 28vw, 28rem)" }}
        >
          2027
        </div>
      </div>

      <div className="relative max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="font-display text-3xl uppercase font-black text-white tracking-tight leading-none">
              {PROFILE.firstName}
              <br />
              <span className="text-[#E60000]">{PROFILE.lastName}</span>
            </div>
            <div className="text-xs tracking-[0.25em] uppercase text-[#8A8A8A] mt-4">
              MB · 6'1" · Class of 2027
            </div>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
              Programs
            </div>
            <ul className="space-y-2 text-sm text-[#cfcfcf]">
              <li>{PROFILE.club} · {PROFILE.clubTeam}</li>
              <li>{PROFILE.school}</li>
              <li>Atlanta, GA</li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
              Direct
            </div>
            <a
              href={`mailto:${PROFILE.email}`}
              className="text-sm text-white hover:text-[#E60000] transition-colors break-all"
              data-testid="footer-email"
            >
              {PROFILE.email}
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-[10px] tracking-[0.25em] uppercase text-[#8A8A8A]">
            © {new Date().getFullYear()} Faith Ahyi-Sena · All rights reserved
          </div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-[#8A8A8A]">
            Recruiting Page · Built for College Coaches
          </div>
        </div>
      </div>
    </footer>
  );
}
